import * as React from 'react';

export const isMovingTowardsElement = (e: React.MouseEvent, elementClass: string, yMovement = 0, xMovement = 0) => {
  const destinationEls = document.elementsFromPoint(e.clientX + xMovement, e.clientY + yMovement);
  return destinationEls.some((el) => el.classList.contains(elementClass));
};
